import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@app/App';
import { ErrorBoundary } from '@sentry/react';

import model from '@model/index';
import fetcher from '@utils/api-service';
import { createStore, StoreProvider } from 'easy-peasy';
import '@app/i18n';
import Sentry from '@app/sentry';
import '@reverse-hr/pattern-library/dist/index.css';
import '@app/assets/stylesheets/main.scss';
import { ErrorScreenGeneric } from '@components/ErrorScreen/index';
import type { TSessionStoreModel } from '@app/models/Session';
import type { TJobStore } from '@model/Job/Job.type';
import type { TCandidatesStore } from '@model/Candidate/Candidate.type';

export interface StoreModel {
  session: TSessionStoreModel;
  job: TJobStore;
  candidates: TCandidatesStore;
}

const store = createStore(model, {
  injections: {
    apiService: { fetcher },
  },
});
Sentry.initialize();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <StoreProvider store={store}>
      <React.StrictMode>
        <ErrorBoundary fallback={<ErrorScreenGeneric />}>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    </StoreProvider>,
  );
}
